// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"ff8411c9","321":"f8c271a1"}[chunkId] + ".chunk.js";
};